import React from 'react';
import styles from './LoginLayout.module.scss';
import Footer from '../../components/footer/Footer';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

const LoginLayout = ({ 
  children = null,
}) => {
  return (
    <div className={styles.layout}>
      <main className={styles.main}>
        <div className={styles.container}>
          { children || <Outlet /> }
        </div>
      </main>
      <footer className={styles.footer}>
        <Footer type="login" />
      </footer>
    </div>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.node,
};

export default LoginLayout;